import type React from 'react';

import { TargetedPetitionList } from './TargetedPetitionList';

export const TargetedPetitionListWrapper: React.FC = () => {
	return (
		<div className="mb-8">
			<TargetedPetitionList />
		</div>
	);
};
